import React, { FC } from "react";
import { useTranslation } from "react-i18next";

export const ConnectionLostMessage: FC = () => {
  const { t } = useTranslation("dialogs");

  return (
    <>
      <span>{t("connectionProblem.connectionLost")}</span>
      <span>{t("connectionProblem.refreshPage")}</span>
    </>
  );
};
